import {
  SIMULATIONS_HOLDINGS_OPTIMIZATION,
  SIMULATIONS_HOLDINGS_OPTIMIZATION_CLEAR,
  SIMULATIONS_INVESTMENT_FORECAST,
  SIMULATIONS_INVESTMENT_RECOMMENDATION,
  SIMULATIONS_HOLDINGS_KPIS,
  SIMULATIONS_EXPECTED_FEES,
} from '../actions/types';

export const initialState = {
  optimizations: {
    portfolioProposals: {},
    modelPortfolios: {},
    mandates: {},
  },
  investmentForecasts: {
    portfolioProposals: {},
    modelPortfolios: {},
    portfolios: {},
  },
  investmentRecommendations: {
    portfolioProposals: {},
    modelPortfolios: {},
    portfolios: {},
  },
  expectedFees: {
    portfolioProposals: {},
    modelPortfolios: {},
    portfolios: {},
  },
  kpis: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SIMULATIONS_HOLDINGS_OPTIMIZATION_CLEAR: {
      const { type, objectId } = action.payload;

      if (state.optimizations[type][objectId]) {
        const { constraints } = state.optimizations[type][objectId];
        state.optimizations[type][objectId] = { constraints };
      }

      return state;
    }
    case SIMULATIONS_HOLDINGS_OPTIMIZATION._SUCCESS: {
      const { type, objectId, optimizations, constraints } = action.payload;

      state.optimizations[type][objectId] = {
        optimizations,
        constraints,
      };

      return state;
    }
    case SIMULATIONS_INVESTMENT_FORECAST._SUCCESS: {
      const { type, objectId, investmentForecast } = action.payload;
      state.investmentForecasts[type][objectId] = investmentForecast;
      return state;
    }
    case SIMULATIONS_INVESTMENT_RECOMMENDATION._SUCCESS: {
      const { type, objectId, investmentRecommendations } = action.payload;
      state.investmentRecommendations[type][objectId] = investmentRecommendations;
      return state;
    }
    case SIMULATIONS_EXPECTED_FEES._SUCCESS: {
      const { type, objectId, expectedFees } = action.payload;
      state.expectedFees[type][objectId] = expectedFees;
      return state;
    }
    case SIMULATIONS_HOLDINGS_KPIS._SUCCESS: {
      state.kpis = action.payload.kpis;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as simulations };
